import React from 'react';
import { Avatar } from '@jjj/components';
import { t } from '../../../../../../../../i18n';
import { TextCell } from '../../../../../../../../components/tables/helperCells';
import { getFormattedDate } from '../../../../../../../../helpers/dateTime';
import { formatMarkupValue } from '../../../../../../../../helpers/markup';
import { getActionColumn } from '../../../../../../../../components/tables/helperColumns';
import { IAgency } from './types';

export const getAgenciesColumns = (popoverContent: (agency: IAgency) => {}, agencyMarkupVisibilityEnabled: boolean) => {
  const notAvailable = t('dash.common.aliases.n/a');

  const columns = [
    {
      title: t('dash.jobs.bookings.poolsColumns.agency_title'),
      key: 'agency_name',
      sorter: false,
      render: (object: IAgency) => (
        <div className="avatar-wrapper">
          <Avatar src={object.agency_logo_url} useDefaultAvatar />
          {TextCell(object.agency_name || notAvailable)}
        </div>
      ),
    },
    {
      title: t('dash.jobs.bookings.poolsColumns.markup_title'),
      key: 'markup',
      align: 'left',
      hide: !agencyMarkupVisibilityEnabled,
      render: (object: IAgency) => TextCell(formatMarkupValue(object)),
    },
    {
      title: t('dash.jobs.bookings.poolsColumns.invitation_time_title'),
      key: 'invite_time',
      sorter: false,
      render: (object: IAgency) =>
        object.invite_time
          ? getFormattedDate({ date: object.invite_time, formatKey: 'datetime_date_numeric' })
          : notAvailable,
    },
    {
      title: t('dash.jobs.bookings.poolsColumns.status_title'),
      key: 'status',
      sorter: false,
      render: (object: IAgency) => TextCell(object?.status?.name || notAvailable),
    },
    getActionColumn((object: IAgency) => popoverContent(object)),
  ];

  return columns;
};

export const getAgenciesToInviteColumns = (
  popoverContent: (agency: IAgency) => {},
  agencyMarkupVisibilityEnabled: boolean,
) => {
  const notAvailable = t('dash.common.aliases.n/a');

  const columns = [
    {
      title: t('dash.jobs.bookings.poolsColumns.agency_title'),
      key: 'agency_name',
      sorter: false,
      width: agencyMarkupVisibilityEnabled ? '50%' : '100%',
      render: (object: IAgency) => (
        <div className="avatar-wrapper">
          <Avatar src={object.agency_logo_url} useDefaultAvatar />
          {TextCell(object.agency_name || notAvailable)}
        </div>
      ),
    },
    {
      title: t('dash.jobs.bookings.poolsColumns.markup_title'),
      key: 'markup',
      align: 'left',
      width: '50%',
      hide: !agencyMarkupVisibilityEnabled,
      render: (object: IAgency) => TextCell(formatMarkupValue(object)),
    },
    getActionColumn((object: IAgency) => popoverContent(object)),
  ];

  return columns;
};
